import { TrackingCheckpointItemSchema } from "./tracking-checkpoint-item";
import { z } from "zod";

export const TrackingItemSchema = z.object({
  id: z.string(),
  tag: z.string(),
  tracking_number: z.string(),
  slug: z.string(),
  shipment_type: z.string().optional(),
  courier_tracking_link: z.string().optional(),
  checkpoints: TrackingCheckpointItemSchema.array(),
  shipment_weight: z
    .object({
      unit: z.string(),
      value: z.number(),
    })
    .optional(),
});

export type TrackingItemType = z.infer<typeof TrackingItemSchema>;
